import React from "react";
import { Spin } from "antd";

const MatchingCount = ({ matchingCount, matchingCountLoading }) => {
  return (
    <div
      style={{
        background: "linear-gradient(135deg, #e6f7ff 0%, #f0f9ff 100%)",
        border: "1px solid #91d5ff",
        borderRadius: "6px",
        padding: "4px 12px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        boxShadow: "0 2px 4px rgba(24, 144, 255, 0.1)",
        height: "32px",
        minWidth: "120px",
      }}
    >
      <span style={{ fontSize: "14px" }}>🎯</span>
      <span style={{ fontSize: "12px", color: "#666", fontWeight: 500 }}>
        Matching:
      </span>
      <span
        style={{
          fontSize: "14px",
          fontWeight: 700,
          color: "#1890ff",
          minWidth: "20px",
          textAlign: "center",
        }}
      >
        {matchingCountLoading ? <Spin size="small" /> : matchingCount || 0}
      </span>
    </div>
  );
};

export default MatchingCount;
